import WhatsAppSectionImage from '@itau-loans-www/assets/images/lp-fgts-whatsapp-phone.png'
import { Button } from '@itau-loans-www/components'

import { useWhatsAppSection } from './hooks'
import './whatsapp-section.scss'

const WhatsAppSection = () => {
  const { handleClick } = useWhatsAppSection()

  return (
    <section className="whatsapp-section">
      <div className="whatsapp-section__content">
        <div className="whatsapp-section__action">
          <h3 className="whatsapp-section__title">
            Agora você pode antecipar seu{' '}
            <span className="whatsapp-section__title--highlight">
              Saque Aniversário FGTS no whatsapp
            </span>
          </h3>
          <p className="whatsapp-section__text">
            Navegar no whatsapp, contratar, ou fazer o que quiser nunca foi tão
            rápido e fácil.
          </p>
          <Button
            className="whatsapp-section__button"
            type="button"
            onClick={handleClick}
          >
            Contratar via whatsapp
          </Button>
        </div>
        <div className="whatsapp-section__aside">
          <img
            src={WhatsAppSectionImage}
            alt={
              'Imagem de um smartphone onde está acontencendo a contratação do Saque-Aniversário FGTS'
            }
            className="whatsapp-section__image"
            width="737"
            height="481"
          />
        </div>
      </div>
    </section>
  )
}

export default WhatsAppSection
